module.exports = __webpack_public_path__ + "static/media/cibmall.54a449a6.png";